export default "__VITE_ASSET__BqaI1W3q__"